import t from "./highrise1525.mjs";
import f from "./highrise1428.mjs";
import m from "./highrise648.mjs";
import p from "./highrise1423.mjs";
var i = t ? t.prototype : void 0, n = i ? i.toString : void 0;
function y(r) {
  if (typeof r == "string")
    return r;
  if (m(r))
    return f(r, y) + "";
  if (p(r))
    return n ? n.call(r) : "";
  var o = r + "";
  return o == "0" && 1 / r == -1 / 0 ? "-0" : o;
}
export {
  y as default
};
